export const getValidUrl = (url) => {
    url = url.match(/^https?:/) ? url : '//' + url;
    return url;
}

export const hasIndeterminateValueCheckbox = (items, selectedSims) => {
    return items.filter(collaborator => collaborator.isInAnySim).length > 0 && selectedSims.length > 1;
}

export const hasIndeterminateValueRadio = (multipleValues) => {
    return multipleValues;
}

export const firstUppercase = (stringVal) => {
    if (!stringVal || stringVal.length === 0) return "";
    return stringVal.charAt(0).toUpperCase() + stringVal.slice(1).toLowerCase();
}

const hexToRgb = (hex) => {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export const getContrastTextColor = (bgColor) => {
    if (!bgColor) {
        return "#000000";
    }
    let rgbBgColor = bgColor;
    if (bgColor.toString().includes("#")) {
        rgbBgColor = hexToRgb(bgColor);
    }
    return (rgbBgColor.r * 0.299 + rgbBgColor.g * 0.587 + rgbBgColor.b * 0.114) > 186 ? "#000000" : "#ffffff";
}

export const isNumeric = (string) => {
    return !isNaN(string);
}

export const createNote = (limitedCharactersText,
                           categoryName = "",
                           areaName = "",
                           dettaglioName = "",
                           referente = "") => {
    const separator = " - ";
    let note = "";
    if (categoryName) {
        note += categoryName + separator;
    }
    if (areaName) {
        note += areaName + separator;
    }
    if (dettaglioName) {
        note += dettaglioName + separator;
    }
    note += limitedCharactersText;
    if (referente) {
        if (referente.added) {
            note += separator + "Nome: " + referente.name + " " +
                "Cognome: " + referente.surname + " " +
                "Telefono: " + referente.telephone + " " +
                "Email: " + referente.email;
        } else {
            note += separator + referente.split("%_%")[1];
        }
    }
    return note;
}

export const simsToIccIdAndMsisdnList = (sims) => {
    let simIccIdList = [];
    if (sims) {
        simIccIdList = sims.map(sim => ({
                iccId: sim.seriale,
                msisdn: sim.numeroDiTelefono
            })
        )
    }
    return simIccIdList;
}

export const simToIccIdAndMsisdn = (sim) => {
    return {
        iccId: sim.seriale,
        msisdn: sim.numeroDiTelefono
    }
}

export const mapDevicesToIccidList = (devices) => {
    let simIccIdList = [];
    if (devices) {
        simIccIdList = devices.map(device => ({
                iccId: device.imei,
                msisdn: null
            })
        )
    }
    return simIccIdList;
}

export const getHowManyFiltersApplied = (filter) => {
    let count = 0;
    Object.keys(filter).forEach(key => {
        if (key !== "numeroDiTelefono" && key !== "numeroSeriale") {
            if (!filter[key].name) {
                if (filter[key].value && filter[key].value.length !== 0) {
                    count++;
                }
            } else {
                if (filter[key].from) {
                    count++;
                }
                if (filter[key].to) {
                    count++;
                }
            }
        }
    })

    return count;
}

export const getTotalHowManyFiltersApplied = (filter) => {
    let count = 0;
    Object.keys(filter).forEach(key => {
        if (!filter[key].name) {
            if (filter[key].value && filter[key].value.length !== 0) {
                count++;
            }
        } else {
            if (filter[key].from) {
                count++;
            }
            if (filter[key].to) {
                count++;
            }
        }
    })

    return count;
}

export const decimalRounder = (value) => {
    return parseFloat(value.toString().replace(",", ".")).toFixed(2);
}

export const getImeiListFromDevices = (deviceList) => {
    return deviceList.map(d => d.imei)
}

export const getImeiListFromDevicesV2 = (deviceList) => {
    return deviceList.map(d => d.codiceImei)
}

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const addFiltersToClientSideTable = (filter, array) => {
    let tmpArray = [...array];
    Object.keys(filter).forEach(k => {
        if (filter[k].value instanceof Array) {
            filter[k].value.forEach(val => {
                if (k === 'tags') {
                    tmpArray = [...tmpArray].filter(el =>
                        val instanceof Object ? el[k].map(tag => tag.label)
                                .some(label => label?.toLowerCase().includes(val.label.toLowerCase())) :
                        el[k].map(tag => tag.label)
                        .some(label => label?.toLowerCase().includes(val.toLowerCase())))
                } else if (k === 'collaborators') {
                    tmpArray = [...tmpArray].filter(el => el[k].map(collab => collab.id)
                        .some(id => id?.toLowerCase().includes(val.id.toLowerCase())))
                } else {
                    tmpArray = [...tmpArray].filter(el => el[k]?.toLowerCase().includes(val?.toLowerCase()))
                }
            })
        } else if (filter[k].name) {
            if (filter[k].from) {
                tmpArray = [...tmpArray].filter(el => getDateWithoutTime(el[k]) >= getDateWithoutTime(filter[k].from))
            }
            if (filter[k].to) {
                tmpArray = [...tmpArray].filter(el => getDateWithoutTime(el[k]) <= getDateWithoutTime(filter[k].to))
            }
        } else {
            if (!filter[k].isSensitive)
                tmpArray = [...tmpArray].filter(el => el[k] === filter[k].value || !filter[k].value.trim())
            else
                tmpArray = [...tmpArray].filter(el => (el[k]?.toLowerCase() ?? "").includes(filter[k].value.toLowerCase()))
        }
    })
    return tmpArray;
}

const getDateWithoutTime = (dateString) => {
    if (dateString) {
        const date = new Date(dateString)
        date.setHours(0, 0, 0, 0)
        return date.getTime()
    }
    return ""
}

export const getMsisdnWithoutPrefix = (msisdn) => {
    if (msisdn.includes('+39'))
        return msisdn.substring(3)
    return msisdn
}

export const handleChangeIndeterminate = (array, length, index) => {
    let tmp = [...array];
    /**
     * Check if there is collaborator in some SIM
     * and put corresponding check
     */
    if (tmp[index].isInAnySim === true && length > 1) {
        tmp[index].isInAnySim = false;
    } else {
        tmp[index].checked = !tmp[index].checked;
    }
    return tmp;
};

export const mapToIccIdList = (simList) => {
    return simList.map(sim => sim.seriale)
}

export const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min)) + min
}

export const replaceCommaWithPoint = (value) => {
    return value.replace(/,/g, '.')
}

export const executeOnEnterPress = (e, methodToExecute) => {
    if (e.which === 13)
        methodToExecute()
}

export const getSimTableTooltipContent = (row) => {
    return [
        {textLeft: row.titleLabelFirstRow, textRight: row.labelFirstRow},
        {textLeft: row.titleLabelSecondRow, textRight: row.labelSecondRow}
    ];
}

export const addPlusForMsisdn = (msisdn) => {
    if (!msisdn) return "-"
    return msisdn.includes("+") ? msisdn : `+${msisdn}`
}

export const replacePlus39 = (objectsList, sostitutiveList = []) => {
    if (sostitutiveList.length > 0) {
        return objectsList.map((obj, idx) => ({
            ...obj,
            numeroDiTelefono: obj.numeroDiTelefono?.replace(/^(\+39)/, "+39 "),
            seriale: obj.seriale?.replace(/^(8939)/, "8939 "),
            nuovoSeriale: sostitutiveList[idx].seriale ?? "",
            qrCodeSent: sostitutiveList[idx].statoEffetuata === 'Si' ? 'Effettuata' : 'Non effettuato'
        }))
    } else {
        return objectsList.map((obj) => ({
            ...obj,
            numeroDiTelefono: obj.numeroDiTelefono?.replace(/^(\+39)/, "+39 "),
            seriale: obj.seriale?.replace(/^(8939)/, "8939 "),
        }))
    }
}

export const replacePlus39ESim = (objectsList) => {
    return objectsList.map((obj) => ({
        ...obj,
        numeroDiTelefono: obj.numeroDiTelefono ?
            addPlusForMsisdn(obj.numeroDiTelefono).replace(/^(\+ 39)/, "+39 ")
            : ""
    }))
}